import { gql } from '@apollo/client';
import fetch from '../../core/fetch';

const updatePaymentGatewayLogoMutation = gql`
  mutation updatePaymentGatewayLogo($title: String!, $name: String!, $value: String!) {
    updateSiteSettingsLogo(title: $title, name: $name, value: $value) {
      status
      errorMessage
    }
  }
`;

async function removeLogoFile(fileName) {
  if (!fileName) return;
  await fetch('/removeLogoFile', {
    method: 'post',
    headers: {
      Accept: 'application/json',
      'Content-Type': 'application/json'
    },
    body: JSON.stringify({ fileName }),
    credentials: 'include'
  });
}

export const updatePaymentGatewayLogo = (title, name, value, oldValue) => {
  return async (dispatch, getState, { client }) => {
    const { data } = await client.mutate({
      mutation: updatePaymentGatewayLogoMutation,
      variables: { title, name, value }
    });
    if (data?.updateSiteSettingsLogo?.status !== 'Success') return false;
    if (oldValue && oldValue !== value) await removeLogoFile(oldValue);
    return true;
  };
};
